
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Feature extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public data;
}
